// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falD: CreateIconOptions = {
  "displayName": "FALD",
  "viewBox": "0, 0, 384, 512",
  "d": "M48 64c-8.8 0-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16l112 0c106 0 192-86 192-192s-86-192-192-192L48 64zM0 80C0 53.5 21.5 32 48 32l112 0c123.7 0 224 100.3 224 224s-100.3 224-224 224L48 480c-26.5 0-48-21.5-48-48L0 80z"
};
